import ComplainsContainer from './ComplainsContainer.jsx';
import ComplainDetail from './ComplainDetail.jsx';

export {ComplainsContainer, ComplainDetail}



// WEBPACK FOOTER //
// ./pages/complains/index.js